<div *ngIf="listInfoDoc && listInfoDoc.length > 0">
  <h4 class="uk-card-title title-card uk-width-3-5">Libellé</h4>
  <ul>
    <li *ngFor="let doc of listInfoDoc; index as i">
      <table>
        <tr uk-grid>
          <td class="uk-width-3-5">
            {{ doc.libelle }}
          </td>
          <td class="uk-width-2-5 btnsComponent">
            <a href="{{ listUrlDoc && listUrlDoc.length ? listUrlDoc[i] : listInfoDoc[i].url }}">
              <button 
              kendoButton 
              [primary]="true" 
              style="margin-right: 2px;" 
              class="primary-background"
              [svgIcon] ="svgDownload">
              </button>
            </a>
            <button
              kendoButton
              [primary]="true"
              (click)="open(doc.doc_id ? doc.doc_id : doc.id)"
              class="primary-background"
              [svgIcon] ="svgTrash"
            >
            </button>
          </td>
        </tr>
      </table>
    </li>
  </ul>

  <div class="example-wrapper">
    <kendo-dialog
      title="Confirmation de suppression"
      [minWidth]="250"
      [width]="600"
      *ngIf="popupIsOpen"
      (close)="close()"
    >
      <p class="text-popup">
        Êtes-vous certain(e) de vouloir supprimer ce document ?
      </p>
      <kendo-dialog-actions>
        <button kendoButton class="k-button k-primary " (click)="close()">Annuler</button>
        <button kendoButton class="k-button k-primary " (click)="deleteDoc()">Je confirme !</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>
</div>
